import { FilterChangedEvent, IFloatingFilter, IFloatingFilterParams } from '@ag-grid-community/core';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';

export interface RangeOption {
    min: number;
    max: number;
    label: string;
}

@Component({
    selector: 'app-range-options-floating-filter',
    standalone: false,
    templateUrl: './range-options-floating-filter.component.html',
    styleUrl: './range-options-floating-filter.component.scss',
})
export class RangeOptionsFloatingFilterComponent implements IFloatingFilter, OnInit, OnDestroy {
    public params!: IFloatingFilterParams;
    public form!: FormGroup;
    public options: RangeOption[] = [];
    private sub!: Subscription;

    agInit(params: IFloatingFilterParams): void {
        this.params = params;
    }

    ngOnInit(): void {
        this.options = (this.params.filterParams as any).ranges ?? [];

        this.form = new FormGroup({
            selected: new FormControl<RangeOption | null>(null),
        });

        this.sub = this.form.get('selected')!.valueChanges.subscribe((opt) => {
            const colId = this.params.column.getColId();
            const model = this.params.api.getFilterModel();

            if (opt && typeof opt.min === 'number' && typeof opt.max === 'number') {
                model[colId] = {
                    filterType: 'number',
                    type: 'inRange',
                    filter: opt.min,
                    filterTo: opt.max,
                };
            } else {
                delete model[colId];
            }

            this.params.api.setFilterModel(model);
        });
    }

    onParentModelChanged(parentModel: any, event?: FilterChangedEvent): void {
        const fm = parentModel || {};
        let match: RangeOption | null = null;

        if (fm.filter != null && fm.filterTo != null && !isNaN(fm.filter) && !isNaN(fm.filterTo)) {
            match = this.options.find((o) => o.min === fm.filter && o.max === fm.filterTo) ?? null;
        }

        this.form.get('selected')!.patchValue(match, { emitEvent: false });
    }

    ngOnDestroy(): void {
        this.sub.unsubscribe();
    }
}
